import { Box } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { ClickEventType, queryKeys, useResponsive, VStack } from "goi_common";

import { useState } from "react";

import Slider from "react-slick";
import { ReviewCard } from "./ReviewCard";
import { useQuery } from "react-query";
import { getBestReviews } from "../../remotes/getReviews";

const initialSlide = 0;

export function ReviewSmallCarousel({ event }: { event: ClickEventType }) {
  const [beforeCount, setBeforeCount] = useState<number>(initialSlide);
  const [, setSlider] = useState<Slider | null>();
  const { isBiggerThanLg } = useResponsive();

  const { data: bestReviews } = useQuery(queryKeys.bestReviews, () => getBestReviews());

  return (
    <>
      <VStack gap={0} position="relative" alignItems="center">
        <Box
          width="100%"
          className={isBiggerThanLg ? "subtitle_21_sb" : "subtitle_16_sb"}
          textAlign={isBiggerThanLg ? "center" : "left"}
          padding={isBiggerThanLg ? "10px 28px 10px" : "10px 28px 0"}
        >
          <h3>고이 베스트 후기</h3>
        </Box>
        {bestReviews && (
          <VStack
            maxWidth={isBiggerThanLg ? "1130px" : "100vw"}
            width="100% !important"
            gap={60}
            margin="0 0 10px"
            position="relative"
          >
            <Slide
              initialSlide={initialSlide}
              beforeChange={(_, next) => {
                setBeforeCount(next);
              }}
              arrows={false}
              centerMode={true}
              infinite={true}
              variableWidth={true}
              ref={(s) => setSlider(s)}
            >
              {bestReviews.results?.map((r, index) => (
                <ReviewCard
                  key={r.id + "reviewslick"}
                  {...r}
                  isCurrent={index === beforeCount}
                  event={event}
                />
              ))}
            </Slide>
          </VStack>
        )}
      </VStack>
    </>
  );
}

const Slide = styled(Slider)`
  .slick-track {
    display: flex !important;
  }
  .slick-slide {
    padding: 0 8px;
  }
  .slick-list {
    margin: 0 -8px;
  }
`;
